const linearColor = 'bg-clip-text text-transparent bg-gradient-to-r from-[#FF75E8] to-[#8046F2]'

const Constant = {
    linearColor
}
export default Constant